// extracted by mini-css-extract-plugin
export default {"text":"ProgramUnggulan_text__6ONXJ","programItems":"ProgramUnggulan_programItems__oUFUS"};